export enum PasskeyTransport {
  SYNCED = 'synced',
  USB = 'usb',
  NFC = 'nfc',
  BLUETOOTH = 'bluetooth',
  INTERNAL = 'internal',
  HYBRID = 'hybrid',
  CABLE = 'cable',
}
